import { isThirdPartyIntegrations } from 'app/policies/config';
import { USER_ROLES } from 'app/services/users.service';

function canPermissions(user) {
  return user?.role_guid !== USER_ROLES.helpDesk;
}

function canDelete(user) {
  return user?.role_guid !== USER_ROLES.helpDesk && user?.role_guid !== USER_ROLES.publisher;
}

export function permissionsRol(user, { restrictedPrograms = false } = {}) {
  // Un editor invitado solo consume programas ajenos: nada de crear, clonar, borrar ni cambiar su estado.
  const canManage = canPermissions(user) && !restrictedPrograms;

  return {
    readList: true,
    readDetail: canPermissions(user),
    create: canManage,
    update: canManage,
    delete: canDelete(user) && !restrictedPrograms,
    deleteOwner: !restrictedPrograms,
    clone: canManage,

    // TABLE:
    columnISBN: !isThirdPartyIntegrations(user),

    // DETAIL:
    showISBN: !isThirdPartyIntegrations(user),
  };
}
